import { useState, useRef } from "react";
import { useLanguage } from "../context/LanguageContext";

const LANGS = ["en", "pt-br"];

export default function LanguageToggle() {
  const { language, setLanguage } = useLanguage();
  const [open, setOpen] = useState(false);
  const closeTimeout = useRef(null);

  function openMenu() {
    clearTimeout(closeTimeout.current);
    setOpen(true);
  }

  function closeMenu() {
    closeTimeout.current = setTimeout(() => {
      setOpen(false);
    }, 120);
  }

  function handleSelect(lang) {
    setLanguage(lang);
    setOpen(false);
  }

  return (
    <div
      className="relative inline-block"
      onMouseEnter={openMenu}
      onMouseLeave={closeMenu}
    >
      <div className="uppercase text-xs tracking-widest opacity-60 hover:opacity-100 transition cursor-pointer">
        {language}
      </div>

      {open && (
        <div className="absolute right-0 mt-2 z-50 bg-black/70 backdrop-blur-sm px-3 py-2 flex flex-col gap-1">
          {LANGS.map((lang) => (
            <button
              key={lang}
              onClick={() => handleSelect(lang)}
              className="uppercase text-xs tracking-widest text-neutral-300 hover:text-white transition text-left"
            >
              {lang}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
